// to be able to mock the current date for the events page without mocking
// new Date() entirely in the whole application
const getCurrentDate = () => new Date();

export default getCurrentDate;
